<template lang="html">
<div>
    <div class="a-player">
          <audio ref="audio"
                 controls
                 @canplay="player($event,'canplay')"
                 @playing="player($event,'playing')"
                 @play="player($event,'play')"
                 @pause="player($event,'pause')"
                 @waiting="player($event,'waiting')"
                 @error="player($event,'error')"
                 @progress="player($event,'progress')"
                 @timeupdate="player($event,'timeupdate')"
                 @seeked="player($event,'seeked')">
          </audio>
    </div>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import { timeFormate,dateFormate,ismobile } from "@/utils/utils";
import vEmits from "@/utils/vEmits";
import { playHis } from '@/api/song'

export default {
    data(){
        return{
            playSrc:'',
            canplay:'',
            duration:0,
            current:0
        }
    },
    methods:{
        ...mapActions('player',[
             'playStateSet'
        ]),

        storeDispatch:function(e){
             this.playStateSet({
                 key:e.key,
                 val:e.val
             });
        },

        setMedia:function(hisDat){
            playHis({
                tPlayHistory:{
                    allSecond: this.duration,
                    second: this.current,
                    code: "LCP",
                    singleId: this.$store.state.player.songDat[0].icd,
                    source: "wechat",
                    sumDate: dateFormate()
                }
            }).then(res => {

            })
            this.$store.dispatch('player/AplayClean');
            if(this.hls){
                this.hls.destroy();
            };
            // 直接给audio的播放地址赋值
            let urls = hisDat.urls.split(/\//);
            this.$refs.audio.src = "http://audio320.china1896.com/" + urls[urls.length - 1];
            // if(ismobile(1) === 0){
            //     let urls = hisDat.urls.split(/\//);
            //     console.log('urls[urls.length - 1]='+urls[urls.length - 1])
            //     this.$refs.audio.src = "http://audio320.china1896.com/" + urls[urls.length - 1];
            // }else{
            //     this.hls = new Hls(hisDat.data);
            //     this.hls.attachMedia(this.$refs.audio);
            //     this.hls.loadSource(hisDat.urls);
            // }
            this.storeDispatch({
                 key:'songDat',
                 val:hisDat.songDat
            })
        },

        player:function(e,key){
            let vues = this;
            let audio = vues.$refs.audio;
            let handles = {
                play:function(){

                },
                canplay:function(){
                    vues.storeDispatch({key:'duration',val:timeFormate(audio.duration,1)});
                    vues.storeDispatch({key:'dTime',val:audio.duration});
                    this.duration = audio.duration;
                },
                playing:function(){
                    vues.storeDispatch({key:'state',val:'playing'});
                },
                pause:function(){
                    vues.storeDispatch({key:'state',val:'pause'});
                },
                progress:function(e){
                    if(audio.buffered.length > 0){
                        vues.storeDispatch({
                           key:'buffered',
                           val: (audio.buffered.end(0)/audio.duration*100 + '').substr(0,4) + '%'
                        });
                    }
                },
                timeupdate:function(){
                    vues.storeDispatch({key:'currentTime',val:timeFormate(audio.currentTime,1)});
                    vues.storeDispatch({
                       key:'perPlay',
                       val: (audio.currentTime/audio.duration*100 + '').substr(0,4) + '%'
                    });
                    this.current = audio.currentTime;
                },
                error:function(e){
                    vues.storeDispatch({key:'state',val:'pause'});
                },
                waiting:function(){
                    vues.storeDispatch({key:'state',val:'waiting'});
                },
                seeked:function(){

                }
            }

            handles[key]();
        }

    },
    mounted:function(){
        let vues = this;
        this.storeDispatch({key:'audio',val:this.$refs.audio});
        vEmits.$on('setMedia',function(e){
            console.log(e)
             vues.setMedia(e);
        })
    }
}
</script>

<style lang="css" scoped>
    .a-player{
        height: 0px;
        overflow: hidden;
    }
</style>
